import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { RsbService } from 'src/app/service/rsb.service';
@Component({
  selector: 'app-project-specifications',
  templateUrl: './project-specifications.component.html',
  styleUrls: ['./project-specifications.component.css']
})
export class ProjectSpecificationsComponent implements OnInit {
  @Output() showNextPage: EventEmitter<number> = new EventEmitter();
  propertyForm!: FormGroup;
  configuration: any;
  constructor(
    private lookupModel : RsbLookupModel,
    private fb: FormBuilder,
    private route: Router,
    private  rsbService:RsbService
  ) { }
  // masterBedroomWalls:string;
  // masterBedroomFlooring:string;
  // otherBedroomFlooring:string;
  // walls:string;
  // livingAreaFlooring:string;
  specifications:any;
  ngOnInit(): void {
    const vendorProperty = this.lookupModel.getVendorProperty();
    this.specifications = vendorProperty ? vendorProperty.specifcations : {};
    this.configuration = vendorProperty ? vendorProperty.configuration : [];
    this.propertyForm = this.fb.group({
      masterBedroomFlooring:[this.specifications && this.specifications.masterBedroomWalls ? this.specifications.masterBedroomWalls :'' ],
      masterBedroomWalls:[this.specifications && this.specifications.masterBedroomFlooring ? this.specifications.masterBedroomFlooring : ''],
      otherBedroomFlooring:[this.specifications && this.specifications.otherBedroomFlooring ? this.specifications.otherBedroomFlooring : ''],
      walls:[this.specifications && this.specifications.walls ? this.specifications.walls :''],
      livingAreaFlooring:[this.specifications && this.specifications.livingAreaFlooring ? this.specifications.livingAreaFlooring:'']
    })
  }

  back(): void {
    this.showNextPage.emit(6)
  }
  submit(formValue :any) : void {
   this.specifications = formValue
    let property = this.lookupModel.getVendorProperty();
    property.specifications = this.specifications;
    
    // Add companyId, projectStatus, and configuration to payload
    const payload = {
      ...property,
      companyId: property.companyId,
      projectStatus: property.projectStatus,
      configuration: this.configuration
    };
    
    this.lookupModel.setVendorProperty(payload);
    this.rsbService.addBuilderProject(payload).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        if (rsp.contents.projectId) {
          payload.projectId = rsp.contents.projectId;
  
        }
        
      }
    });
    // Navigate to Declaration page instead of dashboard
    this.showNextPage.emit(8);
  }

  get masterBedroomFlooring() {return this.propertyForm.get('masterBedroomFlooring')}

  get masterBedroomWalls() {return this.propertyForm.get('masterBedroomWalls')}

  get otherBedroomFlooring() {return this.propertyForm.get('otherBedroomFlooring')}

  get walls() {return this.propertyForm.get('walls')}

  get livingAreaFlooring() {return this.propertyForm.get('livingAreaFlooring')}

}

